import { useState } from "react";
import { STRINGS_EN } from "../../../../constant";
import zycusLogo from "../../../../assets/zycuscolor.png";
import MerlinAssistLoginCard from "../../../../merlin-assist-common/stories/components/LoginCard/MerlinAssistLoginCard";
import FilterRoatserAccounts from "../FilterRoatserAccounts";
import { emailRegex } from "../../../../constant/regexKeys";
import useThemeMode from "../../../../utils/useThemeMode";
import "./styles.css";

function BrowserAccess() {
  const [username, setUsername] = useState("");
  const [enableFilterAccount, setEnableFilterAccount] = useState(false);
  const [error, setError] = useState(null);
  const { theme, isDark, isLight } = useThemeMode();

  const handleSubmitUserName = () => {
    if (!username.trim() || !isValidEmail(username.trim())) {
      setError(STRINGS_EN.MST_EMAIL_ADDRESS_INVALID);
      return;
    }
    setUsername(username);
    setEnableFilterAccount(true);
  };

  const isValidEmail = (email) => {
    return emailRegex.test(email);
  };

  const handleUsernameChange = (value) => {
    setUsername(value);
    setError("");
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter" || e.keyCode === 13) {
      e.preventDefault();
      handleSubmitUserName();
    }
  };

  // Simplified TextField styles - moved complex selectors to CSS
  const textFieldStyles = {
    width: "100%",
  };

  return (
    <>
      {enableFilterAccount ? (
        <>{username && <FilterRoatserAccounts email={username} />}</>
      ) : (
        <MerlinAssistLoginCard
          onClose={undefined}
          cardStyles={{ width: "338px", height: "410px" }}
          logoImageStyles={{ marginTop: "3.75rem" }}
          onKeyDown={handleKeyPress}
          buttons={[
            {
              color: "primary",
              label: STRINGS_EN.MST_Next,
              onClick: handleSubmitUserName,
              size: "medium",
              style: {
                marginTop: "2rem",
                "&:hover": {
                  backgroundColor: "var(--merlin-color-1, #7F60D6)",
                },
              },
              variant: "contained",
            },
          ]}
          credentialKey={{
            label: "",
            styles: {},
          }}
          error={{
            message: error,
            styles: {},
          }}
          isLoginPage
          isNormalButton
          shouldDisplayTextField
          logoImage={zycusLogo}
          onCardClose={() => {}}
          onChange={handleUsernameChange}
          placeholder={{
            label: "Email",
            styles: {
              color: "var(--merlin-color-4, #666666)",
            },
          }}
          subtitle={""}
          texts={[
            {
              emailId: "",
              logInText: STRINGS_EN.MST_Add_account,
              selectedValue: "",
              style: {
                emailId: {
                  marginTop: "2rem",
                },
                logIn: {
                  fontSize: 18,
                  fontWeight: 500,
                  lineHeight: "25.2px",
                },
                selectedValue: {},
              },
            },
          ]}
          title={undefined}
          type="email"
          value={username}
          label={undefined}
          textFieldVariant={undefined}
          captchaFieldType={undefined}
          onChangeCaptcha={undefined}
          captchaValue={undefined}
          sxCaptchaProps={undefined}
          captchatextFieldVariant={undefined}
          captchaplaceholder={undefined}
          captchaerror={undefined}
          captchalabel={undefined}
          captchaImage={undefined}
          handleCaptchaRefresh={undefined}
          sxProps={textFieldStyles}
          className="browser-access-login-card"
        />
      )}
    </>
  );
}

export default BrowserAccess;
